module.exports = __webpack_public_path__ + "static/media/italian_infantry_120.a6d2b09f.png";